import { RestLayoutService } from '@sitecore-jss/sitecore-jss-nextjs';

import { mapSharedPropertiesToFields } from '../../../getters';
import { parseHeaderTags } from '../../htmlParser';
import { AppSettingFields } from './app-settings.model';

export const fetchAppSettings = async (
  locale: string = 'en',
  sitecoreApiHost: string,
  sitecoreApiKey: string,
  sitecoreSiteName: string,
  appSettingsPath: string
): Promise<AppSettingFields | null> => {
  try {
    const layoutService = new RestLayoutService({
      apiHost: sitecoreApiHost,
      apiKey: sitecoreApiKey,
      siteName: sitecoreSiteName,
    });

    const data = await layoutService.fetchLayoutData(appSettingsPath, locale);
    const fields = data.sitecore?.route?.fields;
    if (!fields) return null;

    const settings = mapSharedPropertiesToFields<AppSettingFields>(fields);

    settings.TopSectionParsed = parseHeaderTags(settings.TopSection?.value);
    settings.BottomSectionParsed = parseHeaderTags(settings.BottomSection?.value);

    return settings;
  } catch (error) {
    console.error(`Failed to fetch app settings for locale ${locale}:`, error);
    return null;
  }
};
